export const getUtcOffsetLabel = (timezone: string): string => {
  try {
    const now = new Date();
    const formatter = new Intl.DateTimeFormat('en-US', {
      timeZone: timezone,
      timeZoneName: 'shortOffset',
    });

    const parts = formatter.formatToParts(now);
    const offsetPart = parts.find((p) => p.type === 'timeZoneName');
    const offset = offsetPart?.value ?? '';

    return `${timezone.replace(/_/g, ' ')} (${offset})`;
  } catch {
    return timezone.replace(/_/g, ' ');
  }
};
